import { GatewayIcon } from "@eisox/icons";

import { polymorphicForwardRef } from "~/types/polymorphic-forward-ref";

import { ExpandedItem, type ExpandedItemProps } from "./expended-item";

const ExpandedGateway = polymorphicForwardRef<"div", Omit<ExpandedItemProps, "icon">>(
  (
    {
      backgroundColor = "darkBlue",
      iconProps = {
        backgroundColor: "white",
        color: "darkBlue",
      },
      ...props
    },
    ref,
  ) => (
    <ExpandedItem {...props} ref={ref} icon={<GatewayIcon />} iconProps={iconProps} backgroundColor={backgroundColor} />
  ),
);

ExpandedGateway.displayName = "ExpandedGateway";

export default ExpandedGateway;
export { ExpandedGateway };
